import { Link } from '@inertiajs/react'
import Layout from '../Layout'

interface Account { id: number; name: string; slug: string }
interface Branch {
  id: number
  name: string
  address: string | null
  phone: string | null
  schedule: string | null
  is_active: boolean
}
interface Props { branch: Branch; account: Account; permissions?: { can_manage_branches: boolean } }

export default function BranchesShow({ branch, account, permissions }: Props) {
  return (
    <Layout account={account} permissions={permissions}>
      <div className="max-w-md mx-auto">
        <h1 className="text-2xl font-bold text-[#202020] mb-6">{branch.name}</h1>
        <div className="bg-white p-6 rounded-lg shadow space-y-2">
          <p><span className="text-gray-500">Dirección:</span> {branch.address || '—'}</p>
          <p><span className="text-gray-500">Teléfono:</span> {branch.phone || '—'}</p>
          <p><span className="text-gray-500">Horario:</span> {branch.schedule || '—'}</p>
          <p>
            <span className="text-gray-500">Estado:</span>{' '}
            {branch.is_active
              ? <span className="text-green-600 font-medium">Activa</span>
              : <span className="text-gray-400">Inactiva</span>}
          </p>
        </div>
        <div className="mt-4 flex gap-3">
          <Link href={`/${account.slug}/branches`} className="text-[#55ACEE] hover:underline">← Volver a sucursales</Link>
          <Link href={`/${account.slug}/branches/${branch.id}/edit`} className="text-[#55ACEE] hover:underline">Editar</Link>
        </div>
      </div>
    </Layout>
  )
}
